//API通信のbaseURLや各設定など
import axios, { AxiosResponse, AxiosError } from "axios";

const baseURL = process.env.REACT_APP_BASE_URL;

interface ErrorResponse {
  status: string;
  data: { code: number; message: string };
}

//共通
export const axiosSettings = axios.create({
  baseURL: baseURL,
  headers: {
    "Content-Type": "application/json",
  },
});

//リクエスト時のインターセプター
axiosSettings.interceptors.request.use((config) => {
  //トークンを必ず一緒に送る
  const token = sessionStorage.getItem("token");
  config.headers!.Authorization = `Bearer ${token}`;

  return config;
});

//レスポンス時のインターセプター
axiosSettings.interceptors.response.use(
  (response: AxiosResponse) => {
    return response;
  },
  (error: AxiosError<ErrorResponse>) => {
    const errorData = error.response!.data;
    //unauthorized
    if (errorData.data.code === 401) {
      sessionStorage.clear();
      alert("不正なアクセスです。");
      window.location.href = "/login";
      return;
    }
    return Promise.reject(error);
  }
);
